/**
 * 产物形制图示(2026-07-23 卡片重构 R3)——「点下去出来的是什么东西」的几何表达。
 *
 * ★为什么不用图标字体/插画:形制的信息量在**比例**里(长图细高 / 宽图扁宽 / 套图三个不同框),
 * 一套等宽图标会把这一维抹平。所以这里按 SHAPE_META 的 ratio 现算宽度。
 *
 * ★形状锁:圆角一律 `calc(var(--radius) * n)`,零写死 px(2026-07-22 拍板)。
 * ★颜色一律 `currentColor` —— 由外层 chip 决定,三皮肤自动跟随;不写死任何色值
 *   (编号徽标写死白底、cyber 下浅字浅底看不见,是踩过的同类坑)。
 */
import { SHAPE_META, WAVE_BARS } from "../model/shapes";
import type { SceneShape } from "../model/types";

/** 图示基准高度 = 16px(1rem);各格宽度 = 高 × 比例。
 *  ★14px 时长图只有 4.8px 宽,在 chip 里读成一条线(G-A 门实测)—— 放大一档才立得住。 */
const H = "1rem";

export function SceneShapeGlyph({ shape }: { shape: SceneShape }) {
  const meta = SHAPE_META[shape];

  if (meta.kind === "wave") {
    return (
      <span aria-hidden className="flex items-center gap-[2px]" style={{ height: H }}>
        {WAVE_BARS.map((h, i) => (
          <span
            key={i}
            className="w-[2px] rounded-full bg-current"
            style={{ height: `${h}%` }}
          />
        ))}
      </span>
    );
  }

  return (
    <span aria-hidden className="flex items-end gap-[3px]" style={{ height: H }}>
      {meta.ratios!.map((r, i) => (
        <span
          key={i}
          className="relative h-full border border-current"
          style={{ width: `calc(${H} * ${r})`, borderRadius: "calc(var(--radius) * 0.18)" }}
        >
          {meta.badge === "play" && (
            <span
              className="absolute left-1/2 top-1/2 h-0 w-0 border-y-[3px] border-l-[5px] border-y-transparent border-l-current"
              style={{ transform: "translate(-40%, -50%)" }}
            />
          )}
          {!!meta.bands &&
            Array.from({ length: meta.bands }).map((_, b) => (
              <span
                key={b}
                className="absolute left-[15%] right-[15%] h-px bg-current opacity-70"
                style={{ top: `${((b + 1) * 100) / (meta.bands! + 1)}%` }}
              />
            ))}
          {meta.badge === "face" && (
            <span
              className="absolute left-1/2 top-[26%] h-[4px] w-[4px] -translate-x-1/2 rounded-full bg-current"
            />
          )}
        </span>
      ))}
    </span>
  );
}
